import { VacancyApplicationMatch } from './Applicant';
import { MediumCacheModel } from './MediumCache';
import { ProfileCompletionModel } from './ProfileCompletion';
import { UserEducationHistoryModel } from './UserEducationHistory';
import { UserSkillModel } from './UserSkill';
import { UserWorkHistoryModel } from './UserWorkHistory';
import { ProfessionExperienceLevel } from './VacancyEnums';
import { VacancyPreferencesModel } from './VacancyPreferences';

export interface ApplicantDigitalCVModel {
  id: string;
  has_cv_file: boolean;
  match: VacancyApplicationMatch;
  matching_skills: UserSkillModel[] | null;
  missing_skills: UserSkillModel[] | null;
  additional_skills: UserSkillModel[] | null;
  first_name: string | null;
  last_name: string | null;
  email: string | null;
  country: string | null;
  city: string | null;
  birth_date: string | null;
  gender: string | null;
  phone_number: string | null;
  activated: string | null;
  password_created: boolean;
  experience_level: ProfessionExperienceLevel;
  visible_to_employers: boolean;
  photo_id: string | null;
  photo: MediumCacheModel | null;
  skills: UserSkillModel[] | null;
  soft_skills: UserSkillModel[] | null;
  knowledge_skills: UserSkillModel[] | null;
  language_skills: UserSkillModel[] | null;
  work_history: UserWorkHistoryModel[] | null;
  education: UserEducationHistoryModel[] | null;
  profile_completion: ProfileCompletionModel | null;
  vacancy_preferences: VacancyPreferencesModel | null;
}
